module.exports = __webpack_public_path__ + "img/capa_6.05c9db52.jpg";